<template>
  <div id="addDeivce" v-loading="isLoging">
    <el-dialog :title="dialogTitle" width="40%" top="2rem" :close-on-click-modal="false" :visible.sync="showDialog"
      :destroy-on-close="true" @close="$emit('close')">
      <div id="shared" style="margin-top: 1rem; margin-right: 100px">
        <el-form ref="addDeivce" :rules="isView ? [] : rules" :model="deviceParam" label-width="140px">
          <el-form-item label="平台名称" prop="platformName">
            <el-input v-model="deviceParam.platformName" clearable placeholder="请输入平台名称" v-if="!isView"></el-input>
            <el-tag size="medium" v-else>{{ deviceParam.platformName }}</el-tag>
          </el-form-item>
          <el-form-item label="本地平台名称" prop="localPlatformName">
            <el-input v-model="deviceParam.localPlatformName" clearable placeholder="请输入本地平台名称"
              v-if="!isView"></el-input>
            <el-tag size="medium" v-else>{{ deviceParam.localPlatformName }}</el-tag>
          </el-form-item>
          <el-form-item label="认证用户ID" prop="gbCode">
            <el-input v-model="deviceParam.gbCode" clearable placeholder="请输入认证用户ID" v-if="!isView"></el-input>
            <el-tag size="medium" v-else>{{ deviceParam.gbCode }}</el-tag>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="deviceParam.password" show-password placeholder="请输入密码" v-if="!isView"></el-input>
            <el-tag size="medium" v-else>{{ deviceParam.password }}</el-tag>
          </el-form-item>
          <el-form-item label="SIP服务器ID" prop="serverGbCode">
            <el-input v-model="deviceParam.serverGbCode" clearable placeholder="请输入SIP服务器ID" v-if="!isView"></el-input>
            <el-tag size="medium" v-else>{{ deviceParam.serverGbCode }}</el-tag>
          </el-form-item>
          <el-form-item label="SIP服务域名" prop="serverDomain">
            <el-input v-model="deviceParam.serverDomain" clearable placeholder="请输入SIP服务域名" v-if="!isView"></el-input>
            <el-tag size="medium" v-else>{{ deviceParam.serverDomain }}</el-tag>
          </el-form-item>

          <el-form-item label="IP地址" prop="ip">
            <el-input v-model="deviceParam.ip" clearable placeholder="请输入IP地址" v-if="!isView"></el-input>
            <el-tag size="medium" v-else>{{ deviceParam.ip }}</el-tag>
          </el-form-item>
          <el-form-item label="端口" prop="port">
            <el-input v-model="deviceParam.port" clearable placeholder="请输入端口" v-if="!isView"></el-input>
            <el-tag size="medium" v-else>{{ deviceParam.port }}</el-tag>
          </el-form-item>
          <el-form-item label="注册有效期" prop="expires">
            <el-input v-model="deviceParam.expires" clearable placeholder="请输入注册有效期" v-if="!isView"></el-input>
            <el-tag size="medium" v-else>{{ deviceParam.expires }}</el-tag>
          </el-form-item>
          <el-form-item label="心跳间隔" prop="heartBeatInverval">
            <el-select size="large" v-model="deviceParam.heartBeatInverval" placeholder="请选择" v-if="!isView"
              :disabled="isView" style="width: 100%">
              <el-option key="15" label="15秒" :value="15"></el-option>
              <el-option key="30" label="30秒" :value="30"></el-option>
              <el-option key="60" label="60秒" :value="60"></el-option>
              <el-option key="120" label="120秒" :value="120"></el-option>
            </el-select>
            <el-tag size="medium" v-else>{{
              deviceParam.heartBeatInverval
                ? deviceParam.heartBeatInverval + "秒"
                : ""
            }}</el-tag>
          </el-form-item>

          <el-form-item>
            <div style="float: center">
              <el-button type="primary" @click="onSubmit" v-if="!isView">保存</el-button>
              <el-button @click="$emit('close')">取消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isValidIp } from "@/utils/validate.js";

export default {
  deviceName: "device",
  props: {
    dialogTitle: {
      type: String,
      default: "添加平台",
    },
    // 添加/修改/详情
    handleType: {
      type: String,
      default: "add",
    },
    row: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      listChangeCallback: null,
      showDialog: true,
      isLoging: false,
      deviceParam: {
        gbCode: "",
        password: "",
        platformName: "",
        serverGbCode: "",
        ip: "",
        port: "",
        expires: "",
        heartBeatInverval: "",
        expires: "",
        localPlatformName: ''
      },
      rules: {
        platformName: [
          {
            required: true,
            message: "请输入设备名称",
            trigger: "blur",
          },
        ],
        localPlatformName: [
          {
            required: true,
            message: "请输入本地平台名称",
            trigger: "blur",
          },
        ],
        gbCode: [
          {
            required: true,
            message: "请输入认证用户ID",
          },
          {
            // 只能输入20位数字
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入认证用户ID"));
              } else if (!/^\d{1,20}$/.test(value) || value.length != 20) {
                callback(new Error("只能输入20位数字"));
              } else {
                callback();
              }
            },
          },
        ],
        serverGbCode: [
          {
            required: true,
            message: "请输入SIP服务器ID",
          },
          {
            // 只能输入20位数字,且长度为20
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入SIP服务器ID"));
              } else if (!/^\d{1,20}$/.test(value) || value.length != 20) {
                callback(new Error("只能输入20位数字"));
              } else {
                callback();
              }
            },
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        ip: [
          {
            required: true,
            validator: isValidIp,
            message: "请输入有效的IP地址",
            trigger: "blur",
          },
        ],
        expires: [
          {
            // 只能大于60，小于等于3600
            validator: (rule, value, callback) => {
              if (value < 60 || value > 3600) {
                callback(new Error("大于60，小于等于3600"));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  computed: {
    isView() {
      return this.handleType === "view";
    },
  },
  mounted() {
    if (Object.keys(this.row).length > 0) {
      this.deviceParam = { ...this.row };
    }
    console.log("this.deviceParam", this.deviceParam);
  },
  methods: {
    onSubmit: function () {
      console.log("onSubmit");
      var that = this;
      this.$refs.addDeivce.validate((valid) => {
        if (valid) {
          this.isLoging = true;
          const api = this.row.id
            ? "/api/share/platforms/set"
            : "/api/share/platforms/add";
          that
            .$axios({
              method: "post",
              url: api,
              data: {
                ...this.row,
                ...that.deviceParam,
                port: that.deviceParam.port
                  ? Number(that.deviceParam.port)
                  : "",
                expires: that.deviceParam.expires
                  ? Number(that.deviceParam.expires)
                  : "",
              },
              params: {
                token: this.$cookies.get("session").token,
              },
            })
            .then((res) => {
              if (res.data.code == 0) {
                that.$message({
                  showClose: true,
                  message: "保存成功",
                  type: "success",
                });
                this.$emit("success");
                this.$emit("close");
              } else {
                that.$message.error(that.data.msg);
              }
            })
            .catch(function (error) {
              console.log(error);
            })
            .finally(() => {
              this.isLoging = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    checkExpires: function () {
      if (this.platform.enable && this.platform.expires == "0") {
        this.platform.expires = "300";
      }
    },
  },
};
</script>

<style>
.el-form-item__label {
  text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/HandleSharePlatformDlg.vue